import { useMutation } from '@tanstack/react-query';
import { SessionsAPI } from '@newo/api/gateway';
import type { TSessionsData } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const sessionsAPI = new SessionsAPI(axios);

export const useSessionUpdate = () => {
    return useMutation({
        mutationFn: async ({
            sessionId,
            data
        }: {
            sessionId: string;
            data: TSessionsData;
        }) => sessionsAPI.updateSession(sessionId, data)
    });
};
